<template>
  <div>
    <b-form>
      <b-row>
        <template v-for="config in formData.configs ">
          <b-col cols="12" md="4">

            <validation-provider
                #default="validationContext"
                :name="config.name"
            >

              <b-form-group
                  :label="config.label"
                  :label-for="config.name"
              >
                <b-form-input v-if="config.type === FieldType.TEXT"
                              :state="getValidationState(validationContext)"

                              :id="config.name"
                              v-model="entity[config.name]"
                />
                <b-form-input v-if="config.type === FieldType.PASSWORD"
                              :state="getValidationState(validationContext)"
                              :id="config.name"
                              type="password"
                              v-model="entity[config.name]"
                />
                <b-form-input v-if="config.type === FieldType.EMAIL"
                              :id="config.name"
                              v-model="entity[config.name]"
                />
                <b-form-input v-if="config.type === FieldType.NUMBER"
                              :id="config.name"
                              v-model="entity[config.name]"
                />

                <b-form-checkbox v-if="config.type === FieldType.SWITCH"

                                 :id="config.name"
                                 v-model="entity[config.name]"
                                 switch
                                 inline
                />
                <b-form-textarea
                    v-if="config.type === FieldType.TEXTAREA"
                    :id="config.name"
                    v-model="entity[config.name]"
                    rows="3"
                />
                <v-select v-if="config.type === FieldType.SELECT"
                          v-model="entity[config.name]"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="config.refs.value"
                          :reduce="val => val.value"
                          :clearable="false"
                          :input-id="config.name"
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>

        </template>

      </b-row>
    </b-form>


    <!-- Action Buttons -->
    <b-button
        variant="primary" v-on:click="testFunction"
        class="mb-1 mb-sm-0 mr-0 mr-sm-1"
        :block="$store.getters['app/currentBreakPoint'] === 'xs'"
    >
      Save Changes
    </b-button>
    <b-button
        variant="outline-secondary"
        type="reset"
        :block="$store.getters['app/currentBreakPoint'] === 'xs'"
    >
      Reset
    </b-button>
  </div>
</template>

<script>

import {
  BAvatar,
  BButton,
  BCard,
  BCardHeader,
  BCardTitle,
  BCol,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BMedia,
  BRow,
  BTable,
  BFormTextarea,
  BFormInvalidFeedback,
} from 'bootstrap-vue'

import {avatarText} from '@core/utils/filter'
import {useInputImageRenderer} from '@core/comp-functions/forms/form-utils'
import {ref} from '@vue/composition-api'
import vSelect from 'vue-select'
import store from '@/store'
import {FormConfig, FieldType} from '../../common/index.d.ts'
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import formValidation from '@core/comp-functions/forms/form-validation'


export default {

  components: {
    BButton,
    BMedia,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BTable,
    BCard,
    BCardHeader,
    BCardTitle,
    BFormCheckbox,
    BFormTextarea,
    vSelect,
    BFormInvalidFeedback,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    formData: {
      type: FormConfig,
      required: true,
    },
  },
  setup(props) {
    console.log(props.formData.configs);
    let entity = props.formData.data
    const testFunction = (e) => {
      console.log(props)
      store.dispatch('app-cms/updateEmailConf', {body: entity.value})
          .then(response => {
            console.log("|  -  |")
          })
          .catch(error => {
            if (error.response.status === 404) {

            }
          })
    };

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation()


    let r = {
      refFormObserver,
      getValidationState,
      resetForm,
      avatarText,
      testFunction,
      FieldType,
      entity,
    };

    props.formData.configs.forEach(config => {
      if (config.action) {
        let ref = config.refs;
        r[config.name + "_ref"] = ref;
        store.dispatch(`${config.action}`)
            .then(response => {
              let res = [];
              response.data.data.forEach((f) => {
                res.push({label: f.name, value: f.id})
              })
              //    console.log(config.refs)
              ref.value = res
            })
            .catch(error => {
              if (error.response.status === 404) {

              }
            })
      }
    })
    return r;
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
